export default __webpack_public_path__ + "static/media/user-09.5b8ab77e.jpg";